import { cn } from '@commenda/utils';
import React from 'react';

interface CommendaLayoutAsideProps {
  children: React.ReactNode;
  variant: 'border' | 'detached' | 'plain';
  width?: string;
  className?: string;
}

const VARIANT_CLASSES: Record<CommendaLayoutAsideProps['variant'], string> = {
  border: 'border-l border-border-primary',
  detached:
    'rounded-xl border border-l-0 border-border-primary bg-bg-primary shadow-xs',
  // Sits beside the content card like `detached`, but with no card of its own: no border, no
  // shadow. The chat panel reads as part of the page rather than a second panel competing with the
  // content, and the only white surface inside it is the composer. It carries the page's own fill
  // so the layout's gradient backdrop does not tint the conversation.
  plain: 'bg-bg-light',
};

const CommendaLayoutAside = ({
  children,
  variant,
  width = '400px',
  className,
}: CommendaLayoutAsideProps) => {
  return (
    <aside
      className={cn(
        'shrink-0 overflow-y-auto',
        VARIANT_CLASSES[variant],
        className
      )}
      style={{ width }}
    >
      {children}
    </aside>
  );
};

export { CommendaLayoutAside };
export type { CommendaLayoutAsideProps };
